import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { DatePicker, Button } from "antd";
import moment from 'moment';

import './style.css';
const InputProps = { onChange:()=>{},...DatePicker.defaultProps,...DatePicker.propTypes,}

/**
 *  datePicker日期选择器
 */
class RmtDatePicker extends PureComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: '',
        };
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.updateValue();
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtDatePicker.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state,fieldProps:{...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const { buttonProps={} } = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const { prefixLayout, suffixLayout, style={}, suffixButton } = this.props.fieldProps;
        const { fieldProps, suffixWidth, value } =this.state;
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout&&<div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={style}>
                        <DatePicker getCalendarContainer={triggerNode => triggerNode.parentElement} {...fieldProps} id={this.props.name} value={value ? moment(value) : null} style={{width: "100%"}} format={fieldProps.format?fieldProps.format:"YYYY-MM-DD"} onChange={(e)=> {
                            let date = e ? e.valueOf() : null;
                            this.setState({value: date});
                            fieldProps.onChange(date)
                        }} />
                    </div>
                    {
                        (!!suffixLayout&&!suffixButton)&&<div className="rmt-input-suffix-layout">{suffixLayout}</div>
                    }
                    {
                        (!!suffixButton&&!suffixLayout)&&<div className="rmt-input-suffix-layout">{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}
export default RmtDatePicker;

RmtDatePicker.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtDatePicker.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
}